import { render, staticRenderFns } from "./OrderReport.vue?vue&type=template&id=be3aae78&"
import script from "./OrderReport.vue?vue&type=script&lang=js&"
export * from "./OrderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports